import type { SVGAttributes } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './spinner.module.scss';

type SpinnerSize = 'sm' | 'default' | 'lg';

const sizeMap: Record<SpinnerSize, number> = {
  sm: 14,
  default: 20,
  lg: 28,
};

type SpinnerProps = SVGAttributes<SVGSVGElement> & {
  size?: SpinnerSize;
};

export const Spinner = ({
  size = 'default',
  className,
  ...restProps
}: SpinnerProps) => {
  const px = sizeMap[size];

  return (
    <svg
      aria-hidden="true"
      className={joinCss(css.root, className)}
      fill="none"
      height={px}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width={px}
      {...restProps}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
};
